<template>
    <div v-show="is_window_show" class="win_bg"></div>
    <div v-show="is_window_show" class="win">
        <div class="btn_win_close" @click="is_window_show = false">[X]</div>
        <div class="win-header">Подтвердить удаление</div>
        <br><br>
        <button  class="aspect_btn"  @click="is_window_show = false" >Отмена</button>
        <button  class="aspect_btn" @click="delete_record" >Подтвердить удаление</button>
    </div>
</template>

<script>

export default {
    name: 'Windelete',
    emits: ['delete_record'],
    data() {
        return {
            is_window_show: false,
            record_id: 0,
        }
    },
    methods: {
        delete_record() {
            console.log(this.record_id)
            this.$emit('delete_record', this.record_id)
            this.is_window_show = false
        }
    }
}

</script>


<style scoped>
    .win_bg {
        display: block;
        position: fixed;
        width: 100% !important;
        height: 100% !important;
        background: #000000;
        opacity: 0.6;
        z-index: 999;
        left: 0px;
        top: 0px;
    }
    .win {
        display: block;
        width: 300px !important;
        height: 200px !important;
        position: absolute;
        background: #ffffff;
        left: 50%;
        margin-left: -150px;
        top: 150px;
        z-index: 1000;
        border-radius: 7px;
        box-sizing: border-box;
        padding: 15px;
        margin-bottom: 50px !important;
    }
    .win-header {
        font-size: 20px;
    }
    .btn_win_close {
        display: block;
        position: absolute;
        width: 15px;
        height: 15px;
        cursor: pointer;
        right: 15px;
    }
    .btn_win_close:hover {
        color: blue;
    }
    .aspect_btn {
        margin-left: 10px;
    }
</style>